// skeleton/app/src/app/shared/components/dashboard-expansion-panel/dashboard-expansion-panel.component.ts

import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { resourceUsage } from 'process';
import { GroupModel } from 'src/app/admin/models/group.model';
import { OrganizationModel } from 'src/app/admin/models/organization.model';
import { Constants } from '../../constants';
import { BaseHttpService } from '../../services/basehttp.service';
import { GlobalsessionhandlerService } from '../../services/globalsessionhandler.service';
import { CommonData } from './dashboard-expansion-panel.model';

import { TokenStorageService } from '../../services/token-storage.service';

@Component({
  selector: 'app-dashboard-expansion-panel',
  templateUrl: './dashboard-expansion-panel.component.html',
  styleUrls: ['./dashboard-expansion-panel.component.scss'],
  standalone: false
})
export class DashboardExpansionPanelComponent implements OnInit {

  @Input() props: { srcPath, pageName, lblName, btnCreateText, data, noDataMsg, dashboardType };
  @Input() orgs: OrganizationModel[] = [];
  @Input() loggedInUserGroup: string = "";
  @Output() groupId: EventEmitter<string> = new EventEmitter();
  @Output() createEmitter: EventEmitter<string> = new EventEmitter();
  @Output() resultEmitter: EventEmitter<string> = new EventEmitter();
  @Output() editEmitter: EventEmitter<Object> = new EventEmitter();
  @Output() deleteEmitter: EventEmitter<{ id: string, groupId: string }> = new EventEmitter();
  @Output() shareEmitter: EventEmitter<Object> = new EventEmitter();
  @Output() removeTemplateEmitter: EventEmitter<{ id: string, groupId: string }> = new EventEmitter();
  @Output() createNewTemplateEmitter: EventEmitter<string> = new EventEmitter();
  @Output() takeSurveyEmitter: EventEmitter<Object> = new EventEmitter();
  @Output() resumeSurveyEmitter: EventEmitter<Object> = new EventEmitter();
  @Output() viewSurveyEmitter: EventEmitter<Object> = new EventEmitter();
  @Output() loadSettingsEmitter: EventEmitter<Object> = new EventEmitter();
  @Output() viewCompletedSurveyEmitter: EventEmitter<Object> = new EventEmitter();

  dataNull: boolean = false;
  constant: Constants = new Constants();
  commonData: Array<CommonData> = [];
  faEllipsisV = faEllipsisV;
  loggedInuserId: string;
  loggedInUserTypeId: number;

  constructor(
    private baseHttpService: BaseHttpService,
    private globalsession: GlobalsessionhandlerService,

    private storage: TokenStorageService
  ) { }

  async ngOnInit() {
    // this.loggedInUserGroup = this.storage.get("UserGroupId");

    if (this.props?.data == null) {
      this.dataNull = true;
    }

    const storedUserId = this.storage.get("LoggedInuserId");
    if (storedUserId) {
      // keep existing behavior: uppercase then JSON.parse (as in original code)
      this.loggedInuserId = JSON.parse(storedUserId.toUpperCase());
    }

    const storedUserTypeId = this.storage.get("LoggedInUserTypeId");
    this.loggedInUserTypeId = storedUserTypeId ? +storedUserTypeId : 0;

    this.orgs.forEach(x => {
      x.groups = x.groups.filter(y => y.isDefault == false);
    });
  }

  groupChange(event) {
    this.groupId.emit(event.value);
    this.storage.set('selectedDashboardGroup', event.value);

    console.log(event);

    let grplist: GroupModel[] = [];
    this.orgs.forEach(x => {
      x.groups.forEach(y => {
        grplist.push(y);
      });
    });

    let grpObj = grplist.find(x => x.groupId == event.value);
    if (grpObj != null) {
      this.globalsession.setSelectedGroupObj(grpObj);
    }
  }

  create() {
    this.createEmitter.emit();
  }
  edit(id) {
    this.editEmitter.emit(id);
  }
  result(id) {
    this.resultEmitter.emit(id);
  }
  delete(id, groupId) {
    this.deleteEmitter.emit({ id, groupId });
  }
  share(id) {
    this.shareEmitter.emit(id);
  }
  removeTemplate(id, groupId) {
    this.removeTemplateEmitter.emit({ id, groupId });
  }
  createNewTemplate(id) {
    this.createNewTemplateEmitter.emit(id);
  }
  takeSurvey(id) {
    this.takeSurveyEmitter.emit(id);
  }
  resumeSurvey(id) {
    this.resumeSurveyEmitter.emit(id);
  }
  viewSurvey(id) {
    this.viewSurveyEmitter.emit(id);
  }
  loadSettings(id) {
    this.loadSettingsEmitter.emit(id);
  }
  viewCompletedSurvey(id) {
    this.viewCompletedSurveyEmitter.emit(id);
  }
}
